import { render, staticRenderFns } from "./TurnSingleSelector.vue?vue&type=template&id=c65c80c4&scoped=true&"
import script from "./TurnSingleSelector.vue?vue&type=script&lang=js&"
export * from "./TurnSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65c80c4",
  null
  
)

export default component.exports